import script from "./app-amap-zoom.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-amap-zoom.vue?vue&type=script&setup=true&lang=ts"

import "./app-amap-zoom.vue?vue&type=style&index=0&id=32737b00&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32737b00"]])

export default __exports__